import { Component } from '@angular/core';
import { URL } from '../../../../environments/environment';
import { RACKEO_SITE } from '../../rackeo-site';
import { RackeoCartService } from '../../services/cart.service';

@Component({
  selector: 'app-rackeo-footer-shell',
  templateUrl: './rackeo-footer-shell.component.html',
  styleUrls: ['./rackeo-footer-shell.component.scss']
})
export class RackeoFooterShellComponent {
  readonly URL = URL;
  readonly site = RACKEO_SITE;

  constructor(public readonly cart: RackeoCartService) {}

  get countryName(): string {
    return this.site.countryName;
  }

  get countryBaseUrl(): string {
    return this.site.baseUrl;
  }
}
